import { Box } from "@mui/material";
import * as React from "react";

export interface IDisabledInputClickEnablerProp {
    input: React.ReactNode;
    disabled: boolean;
}

export class DisabledInputClickEnabler extends React.Component<IDisabledInputClickEnablerProp, {}> {
    render() {
        const props = this.props;
        return (props.disabled
            ? <Box sx={{ position: "relative" }}>
                {props.input}
                <Box sx={{ position: "absolute", left: 0, right: 0, top: 0, bottom: 0 }}></Box>
            </Box>
            : props.input
        );
    }
}